import { useContext } from "react";
import { useStore } from "zustand";
import { useShallow } from "zustand/shallow";

import { ActivityFormStoreType } from "./activity_form_store.types";
import { ActivityFormStoreContext } from "./activity_form_store_context";

export const useActivityFormStore = <U>(selector: (state: ActivityFormStoreType) => U) => {
  const store = useContext(ActivityFormStoreContext);
  return useStore(store, useShallow(selector));
};

export const useActivityFormStoreActions = () => {
  const store = useContext(ActivityFormStoreContext);
  return useStore(store, (state) => state.actions);
};
